// Upload page mock data — clusters, slots, master, currency rates.

export interface Cluster {
  id: string;
  label: string;
  company: string;
  period: string;
  filled: number;
  total: number;
}

export interface Slot {
  id: string;
  name: string;
  desc: string;
  file: string | null;
  size: string | null;
  sheets: number | null;
  sheetList?: string[];
  valid: true | false | 'warn' | null;
  validMsg?: string;
  modified: string | null;
  uploadedBy?: string;
  warn?: string;
  planned?: boolean;
}

export interface Master {
  file: string;
  size: string;
  version: string;
  modified: string;
  uploadedBy: string;
  sheets: number;
  note: string;
}

export interface Rate {
  code: string;
  name: string;
  buy: number;
  sell: number;
  source: string;
  frozen: boolean;
}

export const CLUSTERS: Cluster[] = [
  { id: 'dd_1q26', label: 'dd · 1 кв. 2026', company: 'Delta Doors',       period: 'Q1 2026', filled: 8, total: 8 },
  { id: 'sd_1q26', label: 'sd · 1 кв. 2026', company: 'Senim Doors',       period: 'Q1 2026', filled: 7, total: 8 },
  { id: 'kl_1q26', label: 'kl · 1 кв. 2026', company: 'Kendala Logistics', period: 'Q1 2026', filled: 4, total: 8 },
  { id: 'ki_1q26', label: 'ki · 1 кв. 2026', company: 'Kendala Impex',     period: 'Q1 2026', filled: 6, total: 8 },
  { id: 'dk_1q26', label: 'dk · 1 кв. 2026', company: 'Двери.Класс',       period: 'Q1 2026', filled: 8, total: 8 },
  { id: 'cn_1q26', label: 'cn · 1 кв. 2026', company: 'ЦН недвижимость',   period: 'Q1 2026', filled: 5, total: 8 },
];

export const REQUIRED_SLOTS: Slot[] = [
  { id: '7111', name: '7111', desc: 'Себестоимость реализованных товаров',
    file: 'osv_7111_2026Q1_dd.xlsx', size: '142 KB', sheets: 3, sheetList: ['Свод', 'Реализация', 'Импорт'],
    valid: true, modified: '28.04 11:02', uploadedBy: 'Г. Касенова' },
  { id: '7211', name: '7211', desc: 'Доходы от реализации',
    file: 'osv_7211_2026Q1_dd.xlsx', size: '218 KB', sheets: 4, sheetList: ['Свод', 'Стандарт', 'Экспорт', 'Услуги'],
    valid: true, modified: '28.04 11:02', uploadedBy: 'Г. Касенова' },
  { id: '7470', name: '7470', desc: 'Административные расходы',
    file: 'osv_7470_2026Q1_dd.xlsx', size: '96 KB', sheets: 2, sheetList: ['Свод', 'Детализация'],
    valid: true, modified: '28.04 11:03', uploadedBy: 'Г. Касенова', warn: 'устарел: 1С обновил выгрузку 29.04 09:14' },
  { id: 'osv', name: 'osv', desc: 'Оборотно-сальдовая ведомость',
    file: 'osv_main_2026Q1_dd.xlsx', size: '1.2 MB', sheets: 1, sheetList: ['ОСВ'],
    valid: true, modified: '28.04 11:04', uploadedBy: 'Г. Касенова' },
  { id: '1010', name: '1010', desc: 'Касса · NEW (план Q3 2026)',
    file: null, size: null, sheets: null, valid: null, modified: null, planned: true },
  { id: '3310', name: '3310', desc: 'Расчёты с поставщиками · NEW (план Q3 2026)',
    file: null, size: null, sheets: null, valid: null, modified: null, planned: true },
];

export const OPTIONAL_SLOTS: Slot[] = [
  { id: 'sole_7211', name: 'sole_7211', desc: 'ИП — доходы',
    file: 'sole_7211_2026Q1_dd.xlsx', size: '48 KB', sheets: 1, valid: true, modified: '28.04 11:05' },
  { id: 'sole_7212', name: 'sole_7212', desc: 'ИП — корректировка доходов',
    file: 'sole_7212_2026Q1_dd.xlsx', size: '12 KB', sheets: 1, valid: true, modified: '28.04 11:05' },
  { id: 'sole_7111', name: 'sole_7111', desc: 'ИП — себестоимость',
    file: 'sole_7111_2026Q1_dd.xlsx', size: '36 KB', sheets: 1, valid: true, modified: '28.04 11:05' },
  { id: 'sov_dohod', name: 'отчёт_совокупный_доход', desc: 'Отчёт о совокупном доходе',
    file: 'sov_dohod_2026Q1_dd.xlsx', size: '58 KB', sheets: 2,
    valid: 'warn', validMsg: 'не найден лист «Свод» — пересохрани из 1С',
    modified: '27.04 16:48', uploadedBy: 'А. Жумабаева' },
  { id: 'inventory', name: 'inventory', desc: 'Инвентаризация склада',
    file: null, size: null, sheets: null, valid: null, modified: null },
  { id: 'fa_register', name: 'fa_register', desc: 'Реестр основных средств',
    file: null, size: null, sheets: null, valid: null, modified: null },
  { id: 'loans', name: 'loans', desc: 'Реестр займов и процентов',
    file: null, size: null, sheets: null, valid: null, modified: null },
  { id: 'payroll', name: 'payroll', desc: 'ЗУП — свод ФОТ',
    file: null, size: null, sheets: null, valid: null, modified: null },
  { id: 'vat_reg', name: 'vat_reg', desc: 'Реестр НДС',
    file: null, size: null, sheets: null, valid: null, modified: null },
  { id: 'depreciation', name: 'depreciation', desc: 'Амортизация (метод линейный)',
    file: null, size: null, sheets: null, valid: null, modified: null },
];

export const MASTER: Master = {
  file: 'master_2026_q1.xlsx',
  size: '4.8 MB',
  version: 'v.4',
  modified: '28.04 14:22',
  uploadedBy: 'Г. Касенова',
  sheets: 12,
  note: 'Эталонный файл — все расчёты сверяются с ним',
};

export const RATES: Rate[] = [
  { code: 'USD', name: 'Доллар США',       buy: 521.40, sell: 524.10, source: 'НБ РК · 31.03.2026', frozen: true  },
  { code: 'EUR', name: 'Евро',             buy: 562.10, sell: 565.80, source: 'НБ РК · 31.03.2026', frozen: true  },
  { code: 'RUB', name: 'Российский рубль', buy: 5.61,   sell: 5.68,   source: 'НБ РК · 31.03.2026', frozen: true  },
  { code: 'CNY', name: 'Юань',             buy: 71.84,  sell: 72.20,  source: 'НБ РК · 31.03.2026', frozen: true  },
  { code: 'TRY', name: 'Турецкая лира',    buy: 14.92,  sell: 15.08,  source: 'ручной ввод',         frozen: false },
];
